// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1PvOV","container":"card_container__3LviL"};